import css from "styled-jsx/css";
import Colors from "/styles/colors";
import { WHITE_COLOR_NAME, UI_BORDER_LIGHT_COLOR_NAME } from "styles/color-consts";
import { getComponentShadowWithHoverEffect } from "segments/desktop/constants";

const BACK_PART_OFFSET = 50;

export const componentStyles = css.global`
  .home-page-product-card {
    position: relative;
    width: 400px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: left;
    overflow: hidden;
    border-radius: 8px;
    border: 1px solid;
    border-color: ${Colors.gainsboro};
    cursor: pointer;
    padding-bottom: ${`${BACK_PART_OFFSET}px`};
    &.hover {
      ${getComponentShadowWithHoverEffect()}
    }

    .card-checkbox {
      position: absolute;
      display: flex;
      align-items: center;
      top: 20px;
      right: 20px;
      width: 28px;
      height: 28px;
      border: 1px solid;
      border-radius: 3px;
      .vi-sign-wrapper {
        padding-left: 6px;
      }
    }

    .card-top-part {
      padding: 0 16px 0 16px;
      .logo-image-wrapper {
        padding-top: 20px;
        width: 170px;
        height: 60px;

        img {
          width: 100%;
          height: auto;
        }
      }

      .card-text {
        text-align: left;
        font-size: 1rem;
        font-weight: 400;
      }
    }

    .card-image-wrapper {
      width: 100%;
      .picture-component {
        display: flex;
        img {
          width: 100%;
          height: auto;
        }
      }
    }

    .card-back {
      position: absolute;
      top: ${`calc(100% - ${BACK_PART_OFFSET}px)`};
      left: 0;
      right: 0;
      height: 80%;
      background-color: ${Colors[WHITE_COLOR_NAME]};
      text-align: left;
      padding: 10px;
      font-weight: bold;
      padding: 0 16px 16px 16px;
      box-shadow: 0px -4px 20px rgba(0, 0, 0, 0.1);

      .card-bottom-part {
        display: flex;
        flex-direction: row;
        gap: 8px;
        background-color: ${Colors[WHITE_COLOR_NAME]};
        align-items: center;
        height: ${`${BACK_PART_OFFSET}px`};
        .ideal-for-text {
          font-size: 0.875rem;
          font-weight: 400;
        }
        .card-departments {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }
      }

      .subtle-line {
        border: 0;
        border-top: 1px solid;
        border-color: ${Colors[UI_BORDER_LIGHT_COLOR_NAME]};
        margin-bottom: 16px;
      }

      .title-wrapper {
        .core-title {
          font-weight: 400;
        }
      }

      .card-use-cases {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 12px;
      }
    }

    &.clicked {
      animation: pulse 0.3s;
    }
  }

  .home-page-product-card .card-back {
    &.up {
      animation: slide-up 1s ease-in-out forwards;
    }

    &.down {
      animation: slide-down 1s ease-in-out forwards;
    }
  }

  @keyframes slide-up {
    0% {
      top: ${`calc(100% - ${BACK_PART_OFFSET}px)`};
    }
    100% {
      top: var(--distance);
    }
  }

  @keyframes slide-down {
    0% {
      top: var(--distance);
    }
    100% {
      top: ${`calc(100% - ${BACK_PART_OFFSET}px)`};
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(0.98);
    }
    100% {
      transform: scale(1);
    }
  }
`;
